/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ITelemetryEvent } from "./TelemetryInterfaces";

export const TELEMETRY_EVENTS = {
	lifecycle_editor_loaded: {
		eventName: "lifecycle_editor_loaded",
		eventParams: {
			event_category: "lifecycle",
			event_label: "Editor Loaded",
			non_interaction: true
		}
	},
	lifecycle_editor_alive: {
		eventName: "lifecycle_editor_alive",
		eventParams: {
			event_category: "lifecycle",
			event_label: "Editor Activity",
			non_interaction: true
		}
	}
};
